<template>
  <div class="wrap">
    <div class="follow" ref="inboxRef">
      <div class="bg_w">
        <span class="span" style="font-size: 13px;min-width: 70px">{{
            group ? $t('select.user') : $t('common.emailbox.select')
          }}：</span>
        <el-select v-model="selectedTeamId" @change="handleSelectUser" :placeholder="$t('common.email.chooseEmail')"
                   style="margin-right: 10px;width: 150px!important;" size="small">
          <el-option
              v-for="item in tableDataSelect"
              :label="item.userName"
              :value="item.userId"
              :key="item.userId"
          />
        </el-select>
        <el-select v-model="configId" style="width: 150px !important;" size="small">
          <el-option :label="$t('common.setting.allEmail')" value="all" id="all"/>
          <el-option
              v-for="item in emailList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
          />
        </el-select>
        <div style="flex-grow: 1;"></div>
      </div>
      <div class="screen">
        <div class="screen_btn">
          <!--          <ElButton size="small" :loading="btnIsLoadingResolve" type="primary" @click="() => handlePass(1)">-->
          <!--            {{ $t('email.list.examine') }}-->
          <!--          </ElButton>-->
          <!--          <ElButton size="small" :loading="btnIsLoadingReject" @click="() => handlePass(2)">-->
          <!--            {{ $t('email.list.examine.reject') }}-->
          <!--          </ElButton>-->
          <ElButton type="primary" size="small" @click="() => handleBatch(1)">{{ $t('common.bulk.delay') }}</ElButton>
          <ElButton size="small" @click="() => handleBatch(2)">{{ $t('common.bulk.cancel') }}</ElButton>
        </div>
        <el-pagination
            v-model:current-page="current"
            v-model:page-size="size"
            small="small"
            v-if="total"
            layout="total, prev, pager, next, jumper"
            :total="total"
            @current-change="handleCurrentChange"
        />
      </div>
      <div class="content">
        <!-- {{ list}} -->
        <div class="Drag2" ref="DragBox">
          <div class="box" ref="box">
            <!--      <div class="left">-->
            <!--        &lt;!&ndash;左侧div内容&ndash;&gt;-->
            <!--      </div>-->
            <!--      <div class="resize" title="左右侧边栏">⋮</div>-->
            <div class="mid">
              <!--右侧div内容-->
              <div class="topBox" :style="{height:followInboxTop+'px'}">
                <!--右上div内容-->
                <ElTable v-loading="loading"
                         :data="list"
                         @selection-change="handleSelectionChange"
                         size="small"
                         ref="tableRef"
                         :height="'auto'"
                         highlight-current-row
                         @current-change="handleCurrentRowChange"
                         :cell-style="rowClassName"
                         :header-cell-style="headerClassName"
                         :row-style="{height: '30px'}"
                         :row-class-name="tableRowClassName"
                         @cell-mouse-enter="mouseEnters"
                         @cell-mouse-leave="mouseLeaves"
                         @sort-change="sort_change"
                         @row-dblclick="handleViewDetail"
                >
                  <el-table-column type="selection" width="20"/>
                  <el-table-column width="20" prop="isStress" sortable="custom"
                                   class-name="sort_ps"
                  >
                    <template #header>
                      <img style="position: absolute;left: 6px;top: 9px;" src="@/assets/email/hp.svg"/>
                    </template>
                    <template #default="scope">
                      <img v-if="scope.row.isStress === 1" style="position: absolute;left: 6px;top: 9px;"
                           @click.stop="() => handleSettingStress(scope, 3)"
                           class="pointer flags_f"
                           src="@/assets/email/hp.svg"/>
                      <img v-else class="pointer flags_f" style="position: absolute;left: 6px;top: 9px;"
                           @click.stop="() => handleSettingStress(scope, 2)"
                           src="@/assets/email/hp1.svg"/>
                    </template>
                  </el-table-column>
                  <el-table-column width="30" prop="isRead" sortable="custom" class-name="sort_ps">
                    <template #header>
                      <img style="position: absolute;left: 8px;top: 9px;" src="@/assets/email/weidu.svg"/>
                    </template>
                    <template #default="scope">
                      <img style="position: absolute;left: 8px;top: 6px" v-if="scope.row.isRead === 1"
                           @click.stop="() => handleSetRead(scope)" class="pointer"
                           src="@/assets/email/yidu.svg"/>
                      <img style="position: absolute;left: 8px;top:9px" v-else class="pointer"
                           @click.stop="() => handleSetRead(scope)"
                           src="@/assets/email/weidu.svg"/>
                    </template>
                  </el-table-column>
                  <el-table-column width="20" prop="fj" sortable="custom" class-name="sort_ps">
                    <template #header>
                      <img style="position: absolute;left: 6px;top:9px" src="@/assets/email/fj.svg"/>
                    </template>
                    <template #default="scope">
                      <img style="position: absolute;left: 6px;top:9px" v-if="scope.row.isExtend === 1" class="pointer"
                           src="@/assets/email/fj.svg"
                           @click.stop="() => handleDownload(scope)"/>
                    </template>
                  </el-table-column>
                  <el-table-column prop="receiveList" :label="$t('common.email.to')" width="200px">
                    <template #default="scope">
                      <!-- 有客户或联系人时 -->
                      <template v-if="scope.row.customerName || scope.row.contactName">
                        <OverflowTooltip
                            :content="scope.row.contactEmail || `${scope.row.customerName} (${scope.row.companyEmail})`"
                            :show-after="1200"
                            :max-width="180"
                        >
                          <router-link :to="`/email/customer/detail/${scope.row.customerId}?type=1`">
          <span
              class="tooltip-content-wrap"
              style="color: #0087ff;width: 100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
          >
            {{ scope.row.customerName }}
          </span>
                          </router-link>
                        </OverflowTooltip>
                      </template>

                      <!-- 有多个收件人 -->
                      <template v-else-if="(scope.row.mailRecipientList?.length || 0) > 1">
                        <OverflowTooltip
                            :content="scope.row.mailRecipientList.join(', ')"
                            :show-after="1200"
                            :max-width="180"
                        >
        <span class="tooltip-content-wrap">
          {{ scope.row.mailRecipientList[0] }} ...
        </span>
                        </OverflowTooltip>
                      </template>

                      <!-- 只有一个收件人或其他情况 -->
                      <template v-else>
                        <OverflowTooltip
                            :content="scope.row.customerName || scope.row.mailRecipientList?.[0] || ''"
                            :show-after="1200"
                            :max-width="180"
                        >
        <span class="tooltip-content-wrap">
          {{ scope.row.customerName || scope.row.mailRecipientList?.[0] }}
        </span>
                        </OverflowTooltip>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column width="18">
                    <template #default="scope">
                      <img
                          v-if="scope.row.urgent === 1"
                          src="../../assets/svg/warning.svg"
                          class="urgent-icon"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column prop="subject" :label="$t('common.subject')">
                    <template #default="scope">
                      <div
                          class="subject-cell"
                          style="display: flex; align-items: center; position: relative;"
                      >
                        <!-- 紧急图标 -->
                        <!--                        <img-->
                        <!--                            v-if="scope.row.urgent === 1"-->
                        <!--                            src="../../assets/svg/warning.svg"-->
                        <!--                            class="urgent-icon"-->
                        <!--                        />-->

                        <!-- 内容部分，是否溢出决定是否显示 tooltip -->
                        <OverflowTooltip
                            :content="scope.row.subject"
                            :show-after="1200"
                        >
                          <a
                              @click.stop="handleViewDetail(scope.row)"
                              class="subject-text"
                          >
                            <span v-html="highlightKeyword(scope.row.subject, searchCount)"></span>
                          </a>
                        </OverflowTooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sendDate" :label="$t('common.email.sendTime')" class-name="sort_ps"
                                   sortable="custom" width="160"/>
                  <el-table-column prop="followTime" :label="$t('common.followup.time')" width="160"/>
                  <el-table-column prop="remark" :label="$t('common.remark')" width="80">
                    <template #default="scope">
                      <div class="flex">
                        <!--                         @click.stop="handleRef(refMap[`${scope.row.id}`], scope.row, 1)"-->
                        <el-icon :ref="(el) => (refMap[`${scope.row.id}`] = el)"
                                 @click.stop="handleClickRemark(scope.row)"
                                 :color="scope.row.remark ? '#40a9ff' : '#dddddd'" style="padding-top: -2px">
                          <el-tooltip
                              v-if="emailListCheckoutTarget.remark"
                              class="box-item"
                              :content="emailListCheckoutTarget.remark"
                              placement="right"
                              :show-after="1200"
                          >
                            <Memo/>
                          </el-tooltip>
                          <Memo v-else/>
                        </el-icon>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" :label="$t('common.cz')" :width="lang==='en'?180:140">
                    <template #default="scope">
                      <el-button link type="primary" size="small" @click="handleReply(scope.row)"
                      >{{ $t('common.followup') }}
                      </el-button
                      >
                      <el-button link type="primary" size="small" @click="handleDelay(scope.row)">{{
                          $t('common.delay')
                        }}
                      </el-button>
                      <el-popconfirm
                          width="220"
                          :confirm-button-text="$t('common.confirm')"
                          :cancel-button-text="$t('common.cancel')"
                          :icon="QuestionFilled"
                          icon-color="#faad14"
                          :title="$t('sys.message.ask.followup.cancel')"
                          @confirm="handleCancel(scope.row)"
                      >
                        <template #reference>
                          <el-button link type="primary" size="small">{{ $t('common.cancel') }}</el-button>
                        </template>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                  <template #empty>
                    <el-empty :description="$t('common.data.empty')" :image="emptyUrl"></el-empty>
                  </template>
                </ElTable>
              </div>
              <div title="移动到边界进行位置调整" class="mover">
                <div class="mail_info" ref="moveTarget">
                  <div class="up_row move"></div>
                  <div style="width: 100%;height: 26px;display: flex">
                    <div class="from over_text">
                      {{ $t('common.email.from') }}：{{ currentMail?.mailBody?.from }}
                    </div>
                    <div class="to over_text" ref="toRef">
                      <el-popover
                          v-if="formatText(currentMail?.mailRecipientVOList, 'to')"
                          :visible="visibleTo"
                          width="500"
                          :show-after="1200"
                          :content="formatText(currentMail?.mailRecipientVOList, 'to')"
                          :effect="'dark'"
                          popper-class="visible"
                      >
                        <template #reference>
                    <span @mouseenter="showPopover(formatText(currentMail?.mailRecipientVOList, 'to'),'to')"
                          @mouseleave="delayedHidePopover('to')">{{
                        $t('common.email.to')
                      }}：{{ formatText(currentMail?.mailRecipientVOList, 'to') }}</span>
                        </template>
                        <div @mouseenter="keepPopoverVisible('to')" @mouseleave="hidePopover('to')">
                          {{ formatText(currentMail?.mailRecipientVOList, 'to') }}
                        </div>
                      </el-popover>
                      <template v-else>
                        {{ $t('common.email.to') }}：{{ formatText(currentMail?.mailRecipientVOList, 'to') }}
                      </template>
                    </div>
                    <div class="cc over_text">
                      <el-popover
                          v-if="formatText(currentMail?.mailRecipientVOList, 'cc')"
                          :visible="visibleCC"
                          width="500"
                          :content="formatText(currentMail?.mailRecipientVOList, 'cc')"
                          :effect="'dark'"
                          popper-class="visible"
                      >
                        <template #reference>
                <span
                    @mouseenter="showPopover(formatText(currentMail?.mailRecipientVOList, 'cc'),'cc')"
                    @mouseleave="delayedHidePopover('cc')"
                >
                {{ $t('common.cc') }}：{{ formatText(currentMail?.mailRecipientVOList, 'cc') }}
                </span>
                        </template>
                        <div @mouseenter="keepPopoverVisible('cc')" @mouseleave="hidePopover('cc')">
                          {{ formatText(currentMail?.mailRecipientVOList, 'cc') }}
                        </div>
                      </el-popover>
                      <template v-else>
                        {{ $t('common.cc') }}：{{ formatText(currentMail?.mailRecipientVOList, 'cc') }}
                      </template>
                    </div>
                  </div>
                  <div class="down_row move"></div>
                </div>
              </div>
              <div class="downBox" :style="{height:`calc(100% - ${followInboxTop + 10}px)`}">
                <!--右下div内容-->
                <!--              <iframe ref="pageframe" id="pageframe"-->
                <!--                      :srcdoc="iframeContent"-->
                <!--                      frameborder="0"-->
                <!--                      :style="{width: '100%',height: '100%'}"-->
                <!--                      :class="detailLoading?'scroll':'scroll loaded'"-->
                <!--              >-->
                <!--                <p>Your browser does not support preview features, please download Google browser or other modern-->
                <!--                  browsers.</p>-->
                <!--              </iframe>-->
                <div v-loading="detailLoading" style="width: 100%;height: 100%">
                  <iframe ref="pageframe" id="pageframe" :srcdoc="iframeContent"
                          frameborder="0"
                          :style="{width: '100%',height: '100%'}"
                          :class="detailLoading?'scroll':'scroll loaded'"
                  >
                    <p>Your browser does not support preview features, please download Google browser or other modern
                      browsers.</p>
                  </iframe>
                  <div v-if="isDragging" id="mask"
                       :style="{width: '100%',height:`calc(100% - ${followInboxTop + 10}px)`,background:'rgba(0,0,0,0)',position:'absolute',zIndex:999,top:followInboxTop+'px'}">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
          v-model="dialogVisible"
          :title="$t('common.yst')"
          width="400"
      >
        <el-date-picker
            size="small"
            v-model="time"
            type="date"
            style="width: 200px;margin: auto;display: flex;margin-top: 10px"
            :disabled-date="disabledDate"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="$t('common.slt')">
        </el-date-picker>
        <template #footer>
        <span class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">{{ $t('common.sss16') }}</el-button>
          <el-button size="small" type="primary" @click="handleEntry">
            {{ $t('common.confirm') }}
          </el-button>
        </span>
        </template>
      </el-dialog>
      <el-dialog
          v-model="tipsVisible"
          align-center
          :title="$t('sys.team.info')"
          :width="'420'"
      >
        <div class="tips_t" style="display: flex; align-items: flex-start;font-size: 14px">
          <div class="t" style="margin-left: 14px;margin-left: 0px !important;">
            {{ $t('common.plqxsz') }}
          </div>
        </div>
        <template #footer>
        <span class="dialog-footer">
          <el-button @click="tipsVisible = false">{{ $t('common.sss16') }}</el-button>
          <el-button type="primary" @click="handleEntryTips">
            {{ $t('common.confirm') }}
          </el-button>
        </span>
        </template>
      </el-dialog>
      <!--组件抽离-->
      <!--    <el-popover-->
      <!--        virtual-triggering-->
      <!--        :virtual-ref="tempRef"-->
      <!--        v-model:visible="visiblePopover"-->
      <!--        placement="top"-->
      <!--        :width="204"-->
      <!--        trigger="click"-->
      <!--        show-after="500"-->
      <!--        popper-class="sp_model_popover"-->
      <!--        :popper-options="{-->
      <!--              modifiers: [{-->
      <!--		          name: 'offset',-->
      <!--		          options: {-->
      <!--			          offset: [8, 8]-->
      <!--		          }-->
      <!--	        }]-->
      <!--	    }">-->
      <!--      <div @mouseenter="keepPopoverVisible()" @mouseleave="hidePopover()">-->
      <!--        <el-input v-model="emailListCheckoutTarget.remark" style="width: 180px;"-->
      <!--                  :placeholder="$t('common.email.setBlockSize')" @keydown.enter.native.stop="okPopover"/>-->
      <!--        <div style="text-align: right; margin: 16px 0 0 0;">-->
      <!--          <el-button size="small" text @click.stop="cancelPopover">{{ $t('common.sss16') }}-->
      <!--          </el-button>-->
      <!--          <el-button size="small" type="primary" @click.stop="okPopover"-->
      <!--          >{{ $t('common.confirm') }}-->
      <!--          </el-button-->
      <!--          >-->
      <!--        </div>-->
      <!--      </div>-->
      <!--    </el-popover>-->
    </div>
  </div>
  <!--   添加备注   -->
  <Remark v-if="visitableRemark" v-model="visitableRemark" @close="closeRemark" :isHeadLine="false"
          :currentItem="currentItem" @getList="getList" :mailId="true"></Remark>
</template>
<script>
import {onMounted, ref, computed, watch, nextTick, onBeforeUnmount} from 'vue';
import {useStore} from 'vuex';
import {useRoute, useRouter} from 'vue-router';
import {ElMessage} from 'element-plus';
import {QuestionFilled} from '@element-plus/icons-vue'
import {requestFollowList, requestBatchUpdateFollow, requestUpdateMailRemark, requestMailAccessory} from '@/api/mail';
import {emptyUrl} from '@/utils/statusParams.js'
import {flexWidth} from "@/utils/tableWidth";
import {debouncePlus, throttle} from "@/utils/mylodash"
import {i18n} from "@/lang";
import Remark from "@/components/Remark/index.vue"
import {getMailByUserId, getMailDetails, tagMail} from "@/api";
import {addImgOnErrorAttribute, containsHtmlTags, convertLinksToHTML, convertToHTML} from "@/utils/iframe";
import {getTeamUserListAll} from "@/api/groups";
import Dialog from "@/components/Dialog.vue";
import OverflowTooltip from "@/components/OverflowTooltip/index.vue";
import {highlightKeyword} from "@/utils/util";
import sessionStore from "@/utils/sessionStore";
import {Storage} from "@/utils/storage";

export default {
  computed: {
    QuestionFilled() {
      return QuestionFilled
    }
  },
  methods: {highlightKeyword, flexWidth},
  components: {
    OverflowTooltip,
    Dialog,
    QuestionFilled,
    Remark,
  },
  setup() {
    const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const teamId = computed(() => store.state.email.teamID);
    const name = ref('');
    const loading = ref(false);
    const current = ref(1);
    const size = ref(20);
    const total = ref(0);
    const list = ref([]);
    const multipleSelection = ref([]);
    const dialogVisible = ref(false);
    const tipsVisible = ref(false);
    const time = ref('');
    const iframeContent = ref('');
    const DragBox = ref(null);
    const dragBoxHeight = ref(0);
    // 上下拖动事件
    const moveTarget = ref(null);
    const detailLoading = ref(false)
    const currentMail = ref({})
    const topBoxValue = ref(0);
    const downBoxValue = ref(0);
    const initialMouseY = ref(0);
    const followInboxHeight = computed(() => store.state.system.followInboxHeight)
    const followInboxTop = computed(() => {
      return topBoxValue.value !== 0 ? topBoxValue.value : store.state.system.followInboxTop > dragBoxHeight.value ? dragBoxHeight.value : store.state.system.followInboxTop
    })
    const isDragging = ref(false);
    const userInfo = computed(() => store.state.user.userInfo)

    const ACCOUNTS_STORAGE_KEY = 'accounts'
    const activeUserId = computed(() => {
      const fromUserInfo = userInfo.value?.id ?? userInfo.value?.userID ?? userInfo.value?.guid ?? userInfo.value?.account
      const fromAccounts = Storage.get(ACCOUNTS_STORAGE_KEY)?.currentId
      const id = fromUserInfo ?? fromAccounts
      return id === undefined || id === null ? '' : String(id)
    })
    // 语言
    const lang = computed(() => store.state.system.langLocal)
    const elementTopRaw = ref(followInboxTop.value);
    const elementTop = computed({
      get() {
        return elementTopRaw.value;
      },
      set(newValue) {
        elementTopRaw.value = newValue;
      },
    });
    const pageframeHeightRaw = ref(followInboxHeight.value);
    const pageframeHeight = computed({
      get() {
        return pageframeHeightRaw.value;
      },
      set(newValue) {
        pageframeHeightRaw.value = newValue;
      },
    });

    const configId = ref('all');
    const selectedTeamId = ref('');
    const selectedFolder = ref("");
    const tableDataSelect = ref([]);
    const emailList = ref([]);
    const selectedUserIdMap = ref({});
    const targetFileList = computed(() => route.path !== '/email/inbox' && route.path !== '/email/has_send' && route.path !== '/email/draft' && route.path !== '/email/waste' && route.path !== '/email/foldergroup' ? [{
      "id": "99999",
      "fileName": i18n.global.t('common.emailbox.receive'),
    }, {
      "id": "99999",
      "fileName": i18n.global.t('common.has.sent'),
    }, ...store.state.sidebar.targetFileList.filter(item => item.id !== selectedFolder.value)] : store.state.sidebar.targetFileList.filter(item => item.id !== selectedFolder.value))

    const teamList = computed(() => store.state.email.teamList)
    const handleSelectUser = async (val) => {
      console.log(val)
      // if (route.path === '/email/foldergroup') {
      console.log(val, 'val', selectedTeamId.value);
      await store.commit("sidebar/setTargetFileList", [])
      await store.dispatch("sidebar/getEmailGroupFileListApis", {teamId: teamId.value, userId: selectedTeamId.value})
      selectedFolder.value = targetFileList.value.filter(item => item.id !== "99999").length >= 1 ? targetFileList.value[1].id : "";
      await getList()
      // }
    }
    const handleSelectFolder = async (val) => {
      console.log(val, 'val')
      selectedFolder.value = val;
      await getList()
    }

    async function getAllUserList() {
      const result = await getTeamUserListAll({teamId: teamId.value});
      if (result.code !== 200) {
        ElMessage.error(result.message)
        return
      }
      console.log(result.result, 'result.result')

      // 如果没有查到相关的id那么就需要跳转到默认 选中项
      // await store.dispatch('email/getTeamList');
      if (result.result && result.result.length === 0) {
        if (teamList.value.length >= 1) {
          const nextTeamId = String(teamList.value[0].id)
          store.commit('email/setCurTeamID', nextTeamId)
        } else {
          store.commit('email/setCurTeamID', '')
          //   如果查询到没有团队的详情的话那么就跳转到首页
          router.push("/dashboard")
        }
      }
      console.log(result.result, 'result.result')
      if (!route.params.folderId) {
        tableDataSelect.value = result.result || [];
      } else {
        tableDataSelect.value = result.result.filter(item => String(item.userId) === activeUserId.value)
      }
      if (tableDataSelect.value.length) {
        console.log(tableDataSelect.value, tableDataSelect.value.find(_ => String(_.userId) === activeUserId.value), 'tableDataSelect.value')
        selectedTeamId.value = tableDataSelect.value.find(_ => String(_.userId) === activeUserId.value)?.userId;
        selectedUserIdMap.value = tableDataSelect.value.reduce((prev, item) => {
          prev[item.id] = item.userId;
          return prev;
        }, {});
      }
    }

    function getMailListConf() {
      getMailByUserId({teamId: teamId.value, userId: selectedTeamId.value || ''})
          .then((res) => {
            // // console.log(res.result, '邮箱配置列表');
            const list = res.result || [];
            emailList.value = list.map(item => ({label: item.username, value: item.id}));
          });
    }

    watch(() => teamId.value, async () => {
      console.log('组件团队ID 监听', teamId.value);
      await getList();
      if (teamId.value) {
        configId.value = 'all';
        await getMailListConf();
        await getAllUserList();
      }
    })
    watch(() => selectedTeamId.value, (value, item) => {
      console.log('组件团队ID 监听', teamId.value);
      if (selectedTeamId.value !== item) {
        // getList();
        getMailListConf();
        // store.dispatch("user/checkUserInfoIsAdmin", {teamId: teamId.value})
      }
    });


    function startDrag(e) {
      e = e || window.event;
      isDragging.value = true;
      initialMouseY.value = e.clientY;
    }

    async function getList(sort) {
      loading.value = true;
      let payload = {
        pageNo: current.value,
        pageSize: size.value,
        teamId: teamId.value,
        mailConfigId: configId.value === 'all' ? null : configId.value,
        userId: selectedTeamId.value,
        // orderTime: 2,
      }
      if (sort) {
        console.log(sort, 'sort')
        payload = {...payload, ...sort}
      }
      const result = await requestFollowList(payload);
      loading.value = false;
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      const {records, total: counts} = result.result;
      list.value = records;
      total.value = counts;
      console.log('跟进列表', result);
    }

    const tableRef = ref(null)

    function handleSelectionChange(val) {
      //判断是否按住shirt键盘
      console.log(isShiftPressed.value);
      endIndex = val.length > 1 ? list.value.findIndex(item => item.id === val[val.length - 1].id) : -1;
      const startIndex = val.length > 1 ? list.value.findIndex(item => item.id === val[val.length - 2].id) : -1;
      console.log(endIndex, startIndex);
      if (isShiftPressed.value && val.length > 1 && endIndex !== startIndex) {
        const start = startIndex < endIndex ? startIndex : endIndex;
        const end = endIndex < startIndex ? startIndex : endIndex;
        // console.log(start, end, '===============');
        for (let i = start; i <= end; i++) {
          const row = list.value[i];
          if (start === i || i === end) {
            continue;
          }
          console.log(row, '更新');
          if (row) {
            tableRef.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
          }
        }
        nextTick(() => {
          multipleSelection.value = tableRef.value.getSelectionRows();
          console.log(tableRef.value.getSelectionRows(), '当前选中行');
        });
      } else {
        //走正常逻辑
        multipleSelection.value = val;
      }
    }


    async function handleCurrentRowChange(current) {
      console.log(current, 'ff');
      if (current) {
        detailLoading.value = true
        try {
          const result = await getMailDetails({id: current.mailId});
          let content = result.result?.mailBody?.content;
          detailLoading.value = false
          const insertionContent = `<script>
            function errorImage(img) {
                console.log(img,'img')
                img.onerror = null;
                img.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVR42mP4//8/AAX+Av4zEpUUAAAAAElFTkSuQmCC"
            }
        <\/script>`;
          if (!content) {
            iframeContent.value = ''
          } else {
            if (containsHtmlTags(content)) {
              const replacedHtmlString = addImgOnErrorAttribute(content)
              console.log('content', replacedHtmlString);
              const res = replacedHtmlString.replace(/(<html[^>]*>)/, '$1' + insertionContent);
              iframeContent.value = res;
            } else {
              // 纯图片需要直接展示
              if (content.indexOf('https://s3gw.cmbimg.com') !== -1) {
                iframeContent.value = content;
              } else {
                iframeContent.value = convertLinksToHTML(convertToHTML(content))
              }
            }
          }
          currentMail.value = result.result;
        } catch (e) {
          detailLoading.value = false
        }
      }
    }

    function handleCurrentChange(page) {
      console.log(page);
      current.value = page;
      getList();
    }

    function formatText(list, type) {
      console.log(list, type);
      if (!list || !list.length) {
        return '';
      }
      const infoMap = list.reduce((prev, item) => {
        if (!prev[item.mailType]) {
          prev[item.mailType] = [];
        }
        prev[item.mailType].push(item.mail);
        return prev;
      }, {});
      return infoMap[type] ? infoMap[type].join(',') : '';
    }

    //取消
    function handleCancel(row) {
      multipleSelection.value = [row];
      time.value = ''
      batch(2);
    }

    //延迟
    function handleDelay(row) {
      multipleSelection.value = [row];
      dialogVisible.value = true;
    }

    //批量操作
    async function batch(type) {
      const result = await requestBatchUpdateFollow({
        type,
        teamId: teamId.value,
        mailFollowDTOList: multipleSelection.value.map(item => ({id: item.id, mailId: item.mailId})),
        time: time.value
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      console.log('批量处理', result);
      await getList();
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')
    }

    //批量操作
    function handleBatch(type) {
      if (!multipleSelection.value.length) {
        ElMessage.error('未选中任何邮件');
        return;
      }
      if (type === 1) {
        dialogVisible.value = true;
      } else {
        tipsVisible.value = true;
      }
    }

    function handleEntry() {
      if (!time.value) {
        ElMessage.warning(i18n.global.t('common.email.chooseTime'));
        return;
      }
      dialogVisible.value = false;
      batch(1);
    }

    function handleEntryTips() {
      tipsVisible.value = false;
      time.value = ''
      batch(2);
    }

    function handleReply(row) {
      console.log(row, 'rows');
      localStorage.setItem('follow', JSON.stringify(row))
      const query = {id: row.mailId, flag: row.flag, type: "follow"};
      if (row.customerId) {
        query.customerId = row.customerId;
      }
      // router.push({
      //   path: '/email/write_mail',
      //   query,
      // });
      const queryString = new URLSearchParams(query).toString();

      // 拼接完整 URL（假设是 hash 模式或 history 模式可视项目结构调整）
      const url = `${location.origin}/email/write_mail?${queryString}`;
      // 在新标签页打开
      window.open(url, '_blank');
      //   取消目标 邮件跟进
      let timer = setTimeout(() => {
        handleCancel(row)
        clearTimeout(timer)
      }, 300)
    }

    function disabledDate(date) {
      return date.getTime() < Date.now();
    }

    watch(() => teamId.value, () => {
      console.log('组件团队ID 监听', teamId.value);
      getList();
    });

    // 页面进行缩放
    const adjustContentPosition = debouncePlus(() => {
      console.log('resize')
      localStorage.setItem("resize", true)
      router.go(0)
    }, 200)

    onMounted(async () => {
      loading.value = true;
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('keyup', handleKeyUp);
      await nextTick()
      if (DragBox.value) {
        dragBoxHeight.value = DragBox.value.offsetHeight - 30;
        // console.log(dragBoxHeight.value, 'dragBoxHeight.value')
      }
      store.commit("sidebar/setTargetFileList", [])
      store.commit("sidebar/setPageSetting", {type: 'pageNo', value: 1})

      store.dispatch("sidebar/getEmailGroupFileListApis", {teamId: teamId.value, userId: activeUserId.value})
      // elementTop.value = tableHeight.value
      store.dispatch('customer/getAreaNames')
      store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value});

      await store.dispatch("system/getTargetHeight", {userId: activeUserId.value})
      dragControllerUD();
      await getAllUserList();
      if (teamId.value) {
        await getList();
      }
      window.addEventListener('resize', adjustContentPosition);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', adjustContentPosition);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    });

    let endIndex = -1;
    //按住shirt键
    const handleKeyDown = (event) => {
      console.log(event.key, 'event.key')
      if (event.key === 'Shift' && event.keyCode === 16) {
        // console.log("进来了-----------------", event.key, event.keyCode);
        isShiftPressed.value = true;
      }
    };

    const handleKeyUp = (event) => {
      if (event.key === 'Shift' && event.keyCode === 16) {
        isShiftPressed.value = false;
      }
    };

    const rowClassName = ({row, column, rowIndex, columnIndex}) => {
      console.log(row, columnIndex, '333')
      if (columnIndex === 2 || columnIndex === 5 || columnIndex === 7 || columnIndex === 8 || columnIndex === 9) {
        return {'text-align': 'center'}
      } else {
        return {'text-align': 'left'}
      }
    }

    const headerClassName = ({row, column, rowIndex, columnIndex}) => {
      if (columnIndex === 2 || columnIndex === 5 || columnIndex === 7 || columnIndex === 8 || columnIndex === 9) {
        return {'text-align': 'center'}
      } else {
        return {'text-align': 'left'}
      }
    }

    const sidebarTargetNumber = computed(() => store.state.countshow.sidebarTargetNumber)
    watch(() => sidebarTargetNumber.value, async () => {
      await getList()
    })

    watch(() => configId.value, async () => {
      await getList();
    });

    // remark
    const refMap = ref([])
    const tempRef = ref(null)
    const visiblePopover = ref(false)
    const emailListCheckoutTarget = ref({remark: ''})
    const handleRef = debouncePlus((ref, item, type) => {
      tempRef.value = ref
      visiblePopover.value = true;
      emailListCheckoutTarget.value = item;
    }, 300)


    // ---------------
    const hidePopoverTimeout = ref(false)
    // 这里是开始点
    const mouseEnters = debouncePlus((row) => {
      emailListCheckoutTarget.value = row;
    }, 200)
    const mouseLeaves = () => {
      hidePopoverTimeout.value = setTimeout(() => {
        visiblePopover.value = false;
      }, 300);
    }
    const keepPopoverVisible = () => {
      if (hidePopoverTimeout.value) {
        clearTimeout(hidePopoverTimeout.value);
        hidePopoverTimeout.value = null;
      }
      visiblePopover.value = true;
    }
    const hidePopover = () => {
      visiblePopover.value = false;
    }
    const cancelPopover = () => {
      visiblePopover.value = false;
      emailListCheckoutTarget.value.remark = ''
    }
    // -----------------
    // 弹窗进行编辑备注
    const visitableRemark = ref(false)
    const currentItem = ref({remark: ""})
    const handleClickRemark = (row) => {
      const {id} = row
      console.log(id, row, 'id')
      currentItem.value = row
      visitableRemark.value = true
    }
    const closeRemark = () => {
      visitableRemark.value = false
    }


    const visibleTo = ref(false)
    const visibleCC = ref(false)

    function showPopover(string = '', flag) {
      if (moveTarget.value) {
        const itemWidth = Math.round((moveTarget.value.clientWidth - 40) * (1 / 3))
        const stringWidth = string.pxWidth('normal 12px PingFangSC, PingFang SC')
        console.log(itemWidth, stringWidth)
        if (stringWidth + 20 > itemWidth) {
          if (flag === "to") {
            visibleCC.value = false;
            visibleTo.value = true;
          } else if (flag === "cc") {
            visibleTo.value = false;
            visibleCC.value = true;
          }
          if (hidePopoverTimeout.value) {
            clearTimeout(hidePopoverTimeout.value);
            hidePopoverTimeout.value = null;
          }
        }
      }
    }

    function delayedHidePopover(flag) {
      hidePopoverTimeout.value = setTimeout(() => {
        flag === "to" ? visibleTo.value = false : visibleCC.value = false;
      }, 200); // Adjust delay as necessary
    }

    const saveTargetHeight = debouncePlus((userId, pageframeHeight, elementTop) => {
      store.dispatch("system/settingTargetHeight", {
        userId,
        followInboxHeight: pageframeHeight,
        followInboxTop: elementTop
      });
    }, 200); // 300ms 防抖延迟

    function dragControllerUD() {
      var resize = document.getElementsByClassName("move");
      var topBox = document.getElementsByClassName("topBox");
      var downBox = document.getElementsByClassName("downBox");
      var box = document.getElementsByClassName("mid");
      console.log(document.getElementsByClassName("move"), resize.length, 'resize.length');
      for (let i = 0; i < resize.length; i++) {
        // 鼠标按下事件
        resize[i].onmousedown = function (e) {
          console.log(resize[i].top);
          //颜色改变提醒
          resize[i].style.background = "#818181";
          // 100 这里是 有上面的 操作栏的高度
          var startY = e.clientY + 120;
          resize[i].top = resize[i].offsetTop;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            isDragging.value = true
            var endY = e.clientY;
            var moveLen = resize[i].top + (endY - startY); // （endY - startY）=移动的距离。resize[i].top+移动的距离=上边区域最后的高度
            var maxT = box[0].clientHeight - resize[i].offsetHeight; // 容器高度 - 上边区域的高度 = 下边区域的高度

            if (moveLen < 30) moveLen = 30; // 上边区域的最小高度为50px
            if (moveLen > maxT - 30) moveLen = maxT - 30; //下边区域最小高度为150px

            resize[i].style.top = moveLen; // 设置上边区域的高度

            for (let j = 0; j < topBox.length; j++) {
              topBox[j].style.height = moveLen + "px";
              topBoxValue.value = moveLen
              downBox[j].style.height = box[0].clientHeight - moveLen - 10 + "px";
              downBoxValue.value = box[0].clientHeight - moveLen - 10
              saveTargetHeight(userInfo.value.id, box[0].clientHeight - moveLen - 10, moveLen);
            }
          };
          // 鼠标松开事件
          document.onmouseup = function () {
            //颜色恢复
            isDragging.value = false
            resize[i].style.background = "#d6d6d6";
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
          };
          resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
          return false;
        };
      }
    }


    function tableRowClassName({row, rowIndex}) {
      return `read_${row.isRead}`;
    }

    const commandList = [1, 0, 1, 0];

    async function handleSettingStress(scope, type) {
      // // console.log(scope.row, type);
      multipleSelection.value = [scope.row];
      handleCommand(type);
      // 更新标志
      // await store.dispatch('countshow/getTeamAllDataApis')
    }

    async function handleCommand(val) {
      // // console.log(val, multipleSelection.value);
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      const type = val === 0 || val === 1 ? 'isRead' : 'isStress';
      requestTagMail(commandList[val], type);
    }

    async function requestTagMail(tag, type) {
      const result = await tagMail({
        [type]: tag,
        mailIdList: multipleSelection.value.map(item => item.mailId),
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')

      if (multipleSelection.value.length === 1) {
        let isStress = multipleSelection.value[0][type]
        console.log(isStress, 'isStress')
        //   软删除
        list.value = list.value.map(item => {
          if (item.mailId === multipleSelection.value[0].mailId) {
            return {...item, [type]: isStress === 1 ? 0 : 1}
          } else {
            return item
          }
        })
      } else {
        // 删除刷新
        await getList()
      }
    }


    const handleSetRead = async (scope) => {
      const isRead = scope.row.isRead;
      const result = await tagMail({
        isRead: isRead === 1 ? 0 : 1,
        mailIdList: [scope.row.mailId],
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      list.value = list.value.map(item => {
        if (item.mailId === scope.row.mailId) {
          return {...item, isRead: isRead === 1 ? 0 : 1}
        } else {
          return item
        }
      })
    }


    async function handleDownload(scope) {
      const result = await requestMailAccessory({id: scope.row.mailId});
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      console.log(result, 'result')
      window.open(`${location.origin}/email/detail/${scope.row.mailId}/${JSON.stringify({
        flag: scope.row.flag ? scope.row.flag : 0,
        isExtend: scope.row.isExtend ? scope.row.isExtend : 0,
        from: scope.row.from
      })}/${props.type}`);
    }

    const sortObj = ref({})

    function sort_change({column, prop, order}) {
      console.log('ffff', column, prop, order)
      if (order != null) {
        const flag = order === 'descending' ? 2 : 1;
        // 映射排序字段到相应的请求参数
        const sortMapping = {
          isStress: 'orderStress',
          isRead: 'orderRead',
          fj: 'orderExtend',
          sendDate: 'orderTime',
          contentSize: 'orderSize'
        };

        // 获取相应的请求参数
        const requestParam = sortMapping[prop];
        sortObj.value = {[requestParam]: flag};
        console.log(sortObj.value, 'sortObj')
        if (requestParam) {
          getList({[requestParam]: flag});
        }
      } else {
        getList()
      }
    }


    const getTargetMailId = ref(null)

    async function handleViewDetail(row) {
      console.log('双击', row, row.mailId);
      // if (props.type === 3) {
      //   const query = {id: row.id, flag: row.flag, type: "resend"};
      //   if (row.flag === 0 && row.customerId) {
      //     query.customerId = row.customerId;
      //   }
      //   router.push({
      //     path: '/email/write_mail',
      //     query,
      //   });
      // } else if (props.type === 2) {
      //   const query = {id: row.id, flag: row.flag, type: "editMail", fromType: props.type};
      //   if (row.flag === 0 && row.customerId) {
      //     query.customerId = row.customerId;
      //   }
      //   router.push({
      //     path: '/email/write_mail',
      //     query,
      //   });
      // } else {
      getTargetMailId.value = row?.mailId
      //邮件已读
      multipleSelection.value = [row]
      // 已读的邮件 避免被重复赋值
      if (row?.isRead !== 1) {
        await requestTagMail(commandList[0], 'isRead');
      }
      window.open(`${location.origin}/email/detail/${row.mailId}/${JSON.stringify({
        flag: row.flag ? row.flag : 0,
        isExtend: row.isExtend ? row.isExtend : 0,
        from: row.from,
        customerId: row.customerId,
      })}/${6}`);

      // window.location.href = `${location.origin}/email/detail/${row.id}/${JSON.stringify({
      //     flag: row.flag ? row.flag : 0,
      //     isExtend: row.isExtend ? row.isExtend : 0,
      //     from: row.from,
      //   })}/${props.type}`;
      await getList();
      // }
    }


    return {
      handleViewDetail,
      tableRef,
      sort_change,
      handleDownload,
      handleSetRead,
      handleCommand,
      handleSettingStress,
      tableRowClassName,
      targetFileList,
      emailList,
      configId,
      handleSelectFolder,
      tableDataSelect,
      selectedFolder,
      getAllUserList,
      handleSelectUser,
      selectedTeamId,
      DragBox,
      dragBoxHeight,
      startDrag,
      currentMail,
      saveTargetHeight,
      elementTop,
      pageframeHeight,
      isDragging,
      dragControllerUD,
      delayedHidePopover,
      showPopover,
      hidePopoverTimeout,
      visibleTo,
      visibleCC,
      formatText,
      iframeContent,
      detailLoading,
      topBoxValue,
      downBoxValue,
      followInboxHeight,
      followInboxTop,
      getList,
      currentItem,
      closeRemark,
      visitableRemark,
      handleClickRemark,
      hidePopover,
      keepPopoverVisible,
      cancelPopover,
      tempRef,
      visiblePopover,
      lang,
      handleRef,
      emailListCheckoutTarget,
      mouseEnters,
      mouseLeaves,
      refMap,
      rowClassName,
      headerClassName,
      name,
      current,
      size,
      list,
      total,
      loading,
      dialogVisible,
      tipsVisible,
      time,
      handleEntry,
      handleReply,
      handleEntryTips,
      disabledDate,
      handleBatch,
      handleCurrentChange,
      handleCurrentRowChange,
      handleSelectionChange,
      handleCancel,
      handleDelay,
      emptyUrl
    }
  }
}
</script>
<style lang="less" scoped>
@import "./less/follow_up";

.tooltip-content-wrap {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  padding: 4px;
}

.urgent-icon {
  width: 15px;
  height: 15px;
  position: relative;
  top: 3px;
}

:deep(.el-button+.el-button) {
  margin-left: 2px !important;
}
</style>
